<template>
  <tr :class="{deleted_property: deleted }">
    <td :class="{ require_field: isMandatory }" v-if="!noName" style="background-color: #f2f2f2;">
      <div style="width:100%; height: 100%; display: flex;padding-right: 4px;">
        <span class="prop-number" v-if="getFSshow('ColumnNum')">{{ num }}</span>
        <span v-for="(action, index) in leftActions" :key="index" class="prop_toolbuttons prop_toolbuttons_left">
          <ToolButton ghost :tool-tip="action.toolTip" :icon="action.icon" :title="action.title" :disabled="action.disabled" v-on:click.stop="()=>action.onClick?.(item)" :helptoken="action.helptoken"/>
        </span>
        <HelpToolTip :text="getTooltipForName()" style="display: flex;flex:1 1;padding: 4px 0;">
          <span class="prop_name">{{ name }}</span>
        </HelpToolTip>
        <v-menu offset-y v-if="unit?.trim() && unitsList && unitsList.length>3 && !readonly" close-on-click>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="prop_unit_selector">
              <span class="prop_unit" v-if="unit?.trim()">{{ unitsList[currentUnitIndex]?.text || unit }}</span>
              <v-icon style="width:16px;color: #ababab;">arrow_drop_down</v-icon>
            </span>
          </template>
          <v-list nav dense style="padding: 0;">
            <v-list-item v-for="(unit, index) in unitsList" :key="index" @click="()=>selectUnit(index)">
              <v-list-item-title style="padding-right: 4px;">{{ unit.text }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <span v-else-if="unit?.trim() && unitsList && unitsList.length>1 && !readonly" class="prop_unit_selector" v-on:click="selectNextUnit">
          <span class="prop_unit" v-if="unit?.trim()">{{ unitsList[currentUnitIndex]?.text || unit }}</span>
          <v-icon style="width:16px;color: #ababab;">arrow_drop_down</v-icon>
        </span>
        <span class="prop_unit" v-else-if="unit?.trim()">{{ unit }}</span>
        <span class="prop_type" v-else-if="getFSshow('ColumnType')">{{ type_view }}</span>
        
      </div>
    </td>
    <td :colspan="noName?2:1">
      <div :class="{
            'value-container':true, 
            'invalid-editor': (isMandatory && !val) || isInvalidValue, 
            'readonly-editor': readonly || !editType,
            'editable-value': (!readonly && editType) || editable,
            'saving-state': waiting
        }">
        <template v-if="noName">
          <span class="prop-number" v-if="getFSshow('ColumnNum')">{{ num }}</span>
          <span v-for="(action, index) in leftActions" :key="index" class="prop_toolbuttons prop_toolbuttons_left">
            <ToolButton ghost :tool-tip="action.toolTip" :icon="action.icon" :title="action.title" v-on:click.stop="()=>action.onClick?.(item)" :helptoken="action.helptoken"/>
          </span>
        </template>
        <template v-if="editType">
          <span style="flex: 1 1" v-if="editType==='text'" >
            <v-text-field 
              ref="inputRef"
              :rules="rules"
              :value="value"
              :disabled="disabled || readonly" 
              :clearable="!isMandatory"
              @click:clear="()=>onClear?.()"
              validate-on-blur hide-details/>
          </span><!-- v-on:blur="(e) => changeElement(e.target.value)" -->
          <span style="flex: 1 1" v-else-if="editType==='number'">
            <v-text-field 
              ref="inputRef"
              type="text"
              :rules="rules"
              :value="value"
              :disabled="disabled || readonly" 
              :clearable="!isMandatory"
              @click:clear="()=>onClear?.()"
              validate-on-blur hide-details/>
          </span><!-- inputmode="numeric"              v-on:blur="(e) => changeNumberElement(e.target.value)" -->
          <span style="flex: 1 1" v-else-if="editType==='textarea'">
            <span v-if="urlList" class="links-in-text">
              <span>Links: </span>
              <span v-for="(data, index) in urlList" :key="index">
                <a v-if="data.isURL" :href="data.val" target="_blank" rel="noopener noreferrer" >{{ data.val?.replaceAll('https://', '').replaceAll('http://', '') }}</a>
              </span>
            </span>
            <v-textarea 
              :rules="rules"
              :value="value"
              :disabled="disabled || readonly"
              rows="1"
              :clearable="!isMandatory"
              @click:clear="()=> onClear?.()"
              v-on:blur="(e) => changeElement(e.target.value)"
              validate-on-blur hide-details auto-grow/>
          </span>
          <span style="flex: 1 1" v-else-if="editType==='select'">
            <v-select 
                required hide-details
                :value="value" 
                :rules="rules" 
                no-data-text=""
                :item-value="itemKey" 
                :item-text="itemText"
                :items="getListWithNotInListValue()" 
                :disabled="disabled || readonly"
                :clearable="!isMandatory"
                @click:clear="()=>onClear?.()"
                @change="(e)=>selectElement(e)">
            </v-select>
          </span>
          <span style="flex: 1 1" v-else-if="editType==='selecttree'">
              <v-select 
                  required hide-selected hide-details
                  :value="value" 
                  :rules="rules" 
                  no-data-text=""
                  :menu-props="{ closeOnContentClick: true }"  
                  :items="[{value: value, text: value_view}]" 
                  :disabled="disabled || readonly"
                  :clearable="!isMandatory"
                  @click:clear="()=>onClear?.()">
              <template v-slot:prepend-item>
                  <v-treeview :items="listData" style="font-size: 14px;" :active="[value]"
                      activatable :item-key="itemKey" dense transition @update:active="(e)=>selectTreeElement(e)">
                  </v-treeview>
              </template>
              </v-select>
          </span>
          <span style="flex: 1 1" v-else-if="editType==='datetime'" class="datetime-editor">
            <v-text-field 
                required hide-details 
                :value="getDateValue()"
                :type="dateType||'date'"
                :rules="rules"
                no-data-text=""
                :clearable="!isMandatory"
                @click:clear="()=>onClear?.()"
                :disabled="disabled || readonly" 
                @change="(e)=>changeDate(e)"/>
          </span>
          <span style="flex: 1 1" v-else-if="editType==='checkbox'">
            <v-switch :input-value=value hide-details :label="value_view" :disabled="disabled || readonly" @change="(e)=>changeElement(e)"/>
          </span>
        </template>
        <template v-else>
          <span class='static-value' v-if="urlList">
            <span v-for="(data, index) in urlList" :key="index">
              <a v-if="data.isURL" :href="data.val" target="_blank" rel="noopener noreferrer" >{{ data.val }}</a>
                <div v-else>{{ data.val }}</div>
            </span>
          </span>
          <span class='static-value' v-else-if="isLink"><a @click="()=>onClick( item )">{{ value_view }}</a></span>
          <span class='static-value' v-else-if="isLinkList"><a v-for="(link, index) in links" @click="()=>onClick( item, link, index )" :key="index">{{ link.text }}</a></span>

          <span class='static-value require_value' v-else-if="!value_view && isMandatory"></span>
          <span class='static-value' v-else>{{ value_view }}</span>
        </template>
        <ToolButton v-if="haveError" ghost danger tool-tip="message.saving_is_failed" icon="error_outline" v-on:click.stop="repeatSave"/>
        
        <span v-if="getFSshow('ColumnAction')">
          <span v-for="(action, index) in rightActions" :key="index" class="prop_toolbuttons prop_toolbuttons_right">
            <ToolButton ghost :tool-tip="action.toolTip" :icon="action.icon" :title="action.title" :disabled="action.disabled" v-on:click.stop="()=>action.onClick?.(item)" :helptoken="action.helptoken"/>
          </span>
        </span>
      </div>
    </td>
  </tr>
</template>

<script>
import ToolButton from '../ToolButton.vue';
import HelpToolTip from '../HelpToolTip';
import FeaturesSet from "@/utils/features"
import Inputmask from "inputmask";

export default {
  name: 'PropertyItem',
  props: {
    item: {type: Object, required: true},
    num: {type: Number},
    name: {default: ""},
    val: {},
    val_view: {type: String || Promise},
    unit: {type: String},
    unit_code: {type: String},
    unitsList: {type: Array},
    type: {type: String},
    type_view: {type: String},

    isMandatory: {type: Boolean},
    noName: {type: Boolean},
    deleted: {type: Boolean},
    readonly: {type: Boolean},
    editable: {type: Boolean},
    disabled: {type: Boolean},

    editType: {type: String},
    fieldMask: {type: String},
    rules: {type: Array},

    listData: {type: Array},
    itemKey: {type: String},
    itemText: {type: String},
    onChanged: {type: Function},
    onUnitChanged: {type: Function},
    onClick: {type: Function},
    onClear: {type: Function},

    dateType: {type: String},

    urlList: {type: Array},
    links: {type: Array},
    isLink: {type: Boolean},
    isLinkList: {type: Boolean},

    leftActions: {type: Array},
    rightActions: {type: Array},

    featurePrefix: {type:String, default: ""}
  },
  data () {
    return {
        fs: FeaturesSet,
        hasChanges: false,
        waiting:false,
        haveError: false,
        lastSaveFunc: null,
        currentUnitIndex: 0,
        value: this.val,
        value_view: this.val_view,
        isInvalidValue: false
    }
  },
  watch:{
    unitsList(){ this.updateCurrentUnit() },
    unit_code(){ this.updateCurrentUnit() },
    fieldMask(){ this.updateMask() },
    val:  {
      immediate: true,
      handler(val){
        if (val?.then){
          this.waiting = true;
          val.then(v => this.value = v).finally(() => {this.waiting = false; this.$forceUpdate()});
        }else{
          this.value = val;
        }
      }
    },
    val_view: {
      immediate: true,
      handler(val_view){
        if (val_view?.then){
          this.waiting = true;
          this.value_view = "";
          val_view.then(v => this.value_view = v).finally(() => {this.waiting = false;this.$forceUpdate()});
        }else{
          if (val_view !== undefined) this.value_view = val_view;
          else this.value_view = this.value ? ""+this.value : "";
        }
      }
    }
  },
  components: {
    ToolButton,
    HelpToolTip,
  },
  methods:{
    getTooltipForName(){
      let tt = '';
      if (this.type) tt+="Type: " + this.type;
      if (this.unit_code) tt+= (tt?"\n":"") + "Unit: "+this.unit_code;
      return tt;
    },
    getFSshow(name){
        return this.fs.show(this.featurePrefix?(this.featurePrefix+'.'+name):name);
    },
    selectTreeElement(elems){
      if (elems[0] !== this.value && elems[0] && this.onChanged) this.wrapLoading(()=>this.onChanged(this.item, elems[0]));
    },
    selectElement(elems){
      if (elems !== this.value && elems && this.onChanged) this.wrapLoading(()=>this.onChanged(this.item, elems));
    },
    getListWithNotInListValue(){
      if (!this.value && (!this.listData || !this.listData.length)) return [];
      if (this.value && !this.listData?.some(i=>i[this.itemKey || 'value'] === this.value))
        return [{[this.itemKey || 'value']: this.value, [this.itemText ||'text']: this.value_view},...this.listData]
      return this.listData;
    },
    changeElement(value){
      if (value !== this.value_view && this.onChanged) this.wrapLoading(()=>this.onChanged(this.item, value));
    },
    changeNumberElement(value){
      if (value) value = parseFloat(value);
      if (value !== this.val && this.onChanged) this.wrapLoading(()=>this.onChanged(this.item, value));
    },
    getDateValue(){
      if( this.dateType === 'date' ){
        if (!this.value) return null;
        return this.$utils.getISOLocaleStringDate( new Date( this.value ), true );
      } else {
        if (!this.value) return null;
        return this.$utils.getISOLocaleStringDate( new Date( this.value.replace( ' ', 'T' ) + 'Z' ) );
      }
    },
    changeDate(value){
      if(value){
        let dt = this.$utils.getDateFromStr( value );
        value = this.dateType === 'date'? this.$utils.getPLMStringDate( dt ) : this.$utils.getPLMStringDateTime( dt );
      }
      if (value !== this.value && this.onChanged) this.wrapLoading(()=>this.onChanged(this.item, value));
    },
    wrapLoading(func){
      const promise = func();
      if (promise?.finally) {
        this.waiting = true;
        promise.catch(()=>{
          this.haveError = true;
          this.lastSaveFunc = func;
        }).finally(()=>{
          this.waiting = false;
        })
      }
    },
    repeatSave(){
      this.haveError = false;
      this.lastSaveFunc && this.wrapLoading(this.lastSaveFunc);
    },
    updateCurrentUnit(){
      if (!this.unitsList) return;
      this.currentUnitIndex = this.unitsList.findIndex(u => u.value === this.unit_code);
    },
    selectNextUnit(){
      this.currentUnitIndex = (this.currentUnitIndex+1) % this.unitsList.length;
      this.onUnitChanged && this.wrapLoading(()=>this.onUnitChanged(this.item, this.unitsList[this.currentUnitIndex]?.value));
    },
    selectUnit(index){
      this.currentUnitIndex = index;
      this.onUnitChanged && this.wrapLoading(()=>this.onUnitChanged(this.item, this.unitsList[this.currentUnitIndex]?.value));
    },
    updateMask(){
      this.updateCurrentUnit();
      const input = this.$refs.inputRef?.$refs?.input;
      let definitions = {
        '9': null,
        'a': { validator: "[A-Za-z\u0410-\u044F\u0401\u0451\u00C0-\u00FF\u00B5]", casing: "lower" },
        '#': { validator: "[0-9\uFF11-\uFF19]" },
        '*': { validator: "*" },
        '?': { validator: "[0-9A-Za-z\u0410-\u044F\u0401\u0451\u00C0-\u00FF\u00B5!#$%&'*+/=?^_`{|}~\\-]" },
        '&': { validator: "[0-9A-Za-z\u0410-\u044F\u0401\u0451\u00C0-\u00FF\u00B5]" },
        '^': { validator: "[0-9A-Za-z\u0410-\u044F\u0401\u0451\u00C0-\u00FF\u00B5]", casing: "upper" },
        'A': { validator: "[A-Za-z\u0410-\u044F\u0401\u0451\u00C0-\u00FF\u00B5]", casing: "upper" },
        '@': { validator: "[A-Za-z\u0410-\u044F\u0401\u0451\u00C0-\u00FF\u00B5]" }
      };
      //console.log("fieldMask:"+this.fieldMask);
      if (input && this.fieldMask){
        let mask = this.fieldMask;
        let maskOptions = {
          groupSeparator: "",
          unmaskAsNumber: true,
          rightAlign: false,
        };
        const mlc = mask.toLowerCase();
        if (mlc.startsWith('numeric')
          ||mlc.startsWith('decimal')
          ||mlc.startsWith('integer')
          ||mlc.startsWith('currency')
          ||mlc.startsWith('percentage')
        ){
          let optStr;
          if (mask[7] === '?') {
            optStr = mask.substring(8);
            mask = mask.substring(0, 7);
          }else if (mask[8] === '?'){
            optStr = mask.substring(9);
            mask = mask.substring(0, 8);
          }else if (mask[10] === '?'){
            optStr = mask.substring(11);
            mask = mask.substring(0, 10);
          }
          if (optStr){
            const reg =/(\w+?)[\s]*=(?:('.*?')|(".*?")|(?:(.*?)(?:&|$)))/g;
            let result = optStr.matchAll(reg);
            result?.forEach(( r=> {
              let paramName = r[1];
              let paramValue = (r[2] && '"'+r[2].slice(1, -1)+'"') || r[3] || r[4];
              try{ maskOptions[paramName] = JSON.parse(paramValue);
              }catch(e){maskOptions[paramName] = paramValue;}
            }))
          }
          definitions = {};
        }else if (mask.toLowerCase().startsWith('datetime')){
          let optStr;
          if (mask[8] === '?') {
            optStr = mask.substring(9);
            mask = mask.substring(0, 8);
          }
          if (optStr){
            const reg =/(\w+?)[\s]*=(?:('.*?')|(".*?")|(?:(.*?)(?:&|$)))/g;
            let result = optStr.matchAll(reg);
            result?.forEach(( r=> {
              let paramName = r[1];
              if (paramName === 'input' || paramName==='output' || paramName==='display') paramName += 'Format';
              let paramValue = (r[2] && '"'+r[2].slice(1, -1)+'"') || r[3] || r[4];
              try{ maskOptions[paramName] = JSON.parse(paramValue);
              }catch(e){maskOptions[paramName] = paramValue;}
            }))
          }
          definitions = {};
        }
        //Inputmask.extendDefinitions({'9': null, 'a': null, '*': null});
        //console.log("maskOptions", maskOptions);

        Inputmask(mask/*"[-]9\\{[.a{1,20|3}]\\}"/*"numeric"*/,{ 
          definitions,
          ...maskOptions,
          "onincomplete": ()=>{ this.isInvalidValue = true;console.log("incomplete", input.value) },
          "oncomplete": ()=>{ this.isInvalidValue = false; console.log("complete", input.value) },
        }).mask(input);
      }else{
        if (input?.inputmask) input.inputmask.remove()
      }
    },
    onBlur(e){
        //console.log("blur", e.target.value);
        if (this.editType==='number'){
          this.changeNumberElement(e.target.value);
        }else{
          this.changeElement(e.target.value);
        }
    }
  },
  mounted(){
    this.updateMask();
    const input = this.$refs.inputRef?.$refs?.input;
    input?.addEventListener('blur', this.onBlur);
  },
  beforeDestroy(){
    const input = this.$refs.inputRef?.$refs?.input;
    input?.removeEventListener('blur', this.onBlur);
  }
}

</script>